export enum PriceTypeEnum {
  DYNAMIC = 'DYNAMIC',
  FIXED = 'FIXED',
}
